const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const DISPLAY_FORMAT = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York',
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});
const DATE_KEY_FORMAT = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/New_York',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export function actionDateInputValue(value: string | null): string {
  if (!value) return '';
  if (DATE_ONLY.test(value)) return value;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? '' : dateKey(date);
}

export function formatActionDate(value: string | null): string {
  if (!value) return 'No due date';
  const date = DATE_ONLY.test(value)
    ? new Date(`${value}T12:00:00-04:00`)
    : new Date(value);
  return Number.isNaN(date.getTime())
    ? 'Date unavailable'
    : DISPLAY_FORMAT.format(date);
}

export function isActionOverdue(
  dueDate: string | null,
  statusCode: string | null,
  now = new Date(),
): boolean {
  if (!dueDate || (statusCode !== 'OPEN' && statusCode !== 'BLOCKED')) {
    return false;
  }
  const dueKey = actionDateInputValue(dueDate);
  return !!dueKey && dueKey < dateKey(now);
}

export function actionTodayDateKey(now = new Date()): string {
  return dateKey(now);
}

function dateKey(date: Date): string {
  const parts = DATE_KEY_FORMAT.formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((item) => item.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}
